export default __webpack_public_path__ + "static/media/EM0333.34I-41690_-24991_0.fd2c94f3.jpg";